import React, { useState } from "react";
import NorthEastRoundedIcon from "@mui/icons-material/NorthEastRounded";
import AttachmentIcon from "@mui/icons-material/InsertLinkRounded";
import Image from "@mui/icons-material/Image";
import Button from "../../../ReUsableComponents/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  RightWrapper,
  Title,
  Row,
  FaviconWrapper,
  AttachmentRightWrapper,
  AttachmentTitleWrapper,
  AttachmentTitle,
  AttachmentTitleIconWrapper,
  AttachmentFooterWrapper,
  AttachmentDate,
  AttachmentOperations,
  Thumbnail,
} from "./styled";
import { attachmentDelete } from "../../../../Services/cardService";
import BasePopover from "../../../ReUsableComponents/BasePopover";
import EditAttachmentPopover from "../Popovers/Attachment/EditAttachmentPopover";
import moment from "moment";
import AddAttachmentPopover from "../Popovers/Attachment/AddAttachmentPopover";
import { DocumentScanner, VideoLibrary } from "@mui/icons-material";
import { isEmpty } from "lodash-es";
import { LoadingScreen } from "../styled";
import CardLoadingSvg from "../../../../Images/cardLoading.svg";
const Attachments = (props) => {
  const card = useSelector((state) => state.card);
  const dispatch = useDispatch();
  const [editPopover, setEditPopover] = useState(null);
  const [popoverComponent, setPopoverComponent] = useState(null);
  const [attachmentPopover, setAttachmentPopover] = useState(null);

  const handleDeleteClick = async (attachmentId) => {
    await attachmentDelete(card.cardId, card.boardId, attachmentId, dispatch);
  };

  const AttachmentFileIcon = (attachment) => {
    const { fileType, thumbnail } = attachment;
    if (!isEmpty(thumbnail)) {
      return <Thumbnail src={thumbnail} />;
    }
    switch (fileType) {
      case "image":
        return thumbnail ? (
          <Thumbnail src={thumbnail} />
        ) : (
          <Image fontSize="large" />
        );
      case "document":
        return <DocumentScanner fontSize="large" />;
      case "video":
        return <VideoLibrary fontSize="large" />;
      default:
        return <AttachmentIcon fontSize="large" />;
    }
  };
  return (
    <>
      <Container>
        <AttachmentIcon fontSize="small" />
        <RightWrapper>
          <Title>Attachments({card.attachments?.length})</Title>
          {card.attachments?.map((attachment) => {
            const validateLink = () => {};
            validateLink();
            return (
              <Row
                key={attachment._id}
                onClick={() => window.open(attachment.link, "_blank")}
              >
                <FaviconWrapper>
                  {AttachmentFileIcon(attachment)}
                </FaviconWrapper>
                <AttachmentRightWrapper>
                  <AttachmentTitleWrapper>
                    <AttachmentTitle>
                      {attachment.name ? attachment.name : attachment.link}
                    </AttachmentTitle>
                    <AttachmentTitleIconWrapper>
                      <NorthEastRoundedIcon fontSize="inherit" />
                    </AttachmentTitleIconWrapper>
                  </AttachmentTitleWrapper>
                  <AttachmentFooterWrapper>
                    <AttachmentDate>
                      {"Added " +
                        moment(attachment.date).format("MMM, DD [at] HH.mm")}
                      <AttachmentOperations
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick(attachment._id);
                        }}
                      >
                        Delete
                      </AttachmentOperations>
                      {" - "}
                      <AttachmentOperations
                        onClick={(e) => {
                          e.stopPropagation();
                          setPopoverComponent(attachment);
                          setEditPopover(e.currentTarget);
                        }}
                      >
                        Edit
                      </AttachmentOperations>
                    </AttachmentDate>
                  </AttachmentFooterWrapper>
                </AttachmentRightWrapper>
              </Row>
            );
          })}

          {props.uploading && (
            <Row style={{ height: 80, width: "100%" }}>
              <LoadingScreen image={CardLoadingSvg} />
            </Row>
          )}
          <Button
            style={{ marginTop: "0.7rem" }}
            onClick={(event) => setAttachmentPopover(event.currentTarget)}
            title="Add an Attachment"
          />
        </RightWrapper>
        {editPopover && (
          <BasePopover
            anchorElement={editPopover}
            closeCallback={() => {
              setEditPopover(null);
            }}
            title="Edit"
            contents={
              <EditAttachmentPopover
                {...popoverComponent}
                closeCallback={() => {
                  setEditPopover(null);
                }}
              />
            }
          />
        )}
        {attachmentPopover && (
          <BasePopover
            anchorElement={attachmentPopover}
            closeCallback={() => {
              setAttachmentPopover(null);
            }}
            title="Attach from..."
            contents={
              <AddAttachmentPopover
                closeCallback={() => {
                  setAttachmentPopover(null);
                }}
              />
            }
          />
        )}
      </Container>
    </>
  );
};

export default Attachments;
